// Branded identifier types. A plain string can't be passed where a TenantId is
// expected (and vice-versa), so id-confusion bugs — the kind that caused the
// `t-1` vs `dev-tenant` mismatch in the previous system — become compile errors.

export type Brand<T, B extends string> = T & { readonly __brand: B }

export type TenantId       = Brand<string, 'TenantId'>
export type UserId         = Brand<string, 'UserId'>
export type ConversationId = Brand<string, 'ConversationId'>
export type SubjectId      = Brand<string, 'SubjectId'>
export type MessageId      = Brand<string, 'MessageId'>
export type ActionId       = Brand<string, 'ActionId'>
export type ProfileId      = Brand<string, 'ProfileId'>
export type ConnectionId   = Brand<string, 'ConnectionId'>

export const asTenantId       = (s: string): TenantId       => s as TenantId
export const asUserId         = (s: string): UserId         => s as UserId
export const asConversationId = (s: string): ConversationId => s as ConversationId
export const asSubjectId      = (s: string): SubjectId      => s as SubjectId
export const asMessageId      = (s: string): MessageId      => s as MessageId
export const asActionId       = (s: string): ActionId       => s as ActionId
export const asProfileId      = (s: string): ProfileId      => s as ProfileId
export const asConnectionId   = (s: string): ConnectionId   => s as ConnectionId

/** Anonymous guests live under this tenant; they bypass cross-tenant scoping but
 *  are still gated by conversation membership. */
export const ANONYMOUS_TENANT = asTenantId('anonymous')
